import React, { useState } from 'react';
import './FullscreenPanel.css';

export interface FullscreenPanelProps {
  children: React.ReactNode;
  /** Rendered next to the fullscreen toggle, inside the panel's own small header row. */
  title?: React.ReactNode;
}

/**
 * Generalizes DetailPane.tsx's existing isFullscreen toggle
 * ({position:'fixed', inset:0, zIndex:10000} on activation) so each of the
 * 5 node-detail tabs gets an independent fullscreen option without
 * reimplementing the toggle 5 times.
 */
export const FullscreenPanel: React.FC<FullscreenPanelProps> = ({ children, title }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <div
      className="fop-fullscreen-panel"
      style={isFullscreen ? { position: 'fixed', inset: 0, zIndex: 10000, background: '#111827' } : undefined}
    >
      <div className="fop-fullscreen-panel__header">
        {title && <span className="fop-fullscreen-panel__title">{title}</span>}
        <span className="fop-fullscreen-panel__spacer" />
        <button
          type="button"
          className="fop-fullscreen-panel__toggle"
          onClick={() => setIsFullscreen((v) => !v)}
          title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
        >
          {isFullscreen ? '⊙' : '⛶'}
        </button>
      </div>
      <div className="fop-fullscreen-panel__body">{children}</div>
    </div>
  );
};
